<template>
  <el-container class="ScheduleBulkChange">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
      >
        <el-form-item 
          prop="schedule_date"
          label="일자" 
        >
          <el-checkbox v-model="selection.schedule_date" />
          <div class="inline pl-default">
            <ADatePicker
              v-model="data.schedule_date" 
              @change="handleChangeScheduleDate"
            />
          </div>
        </el-form-item>
        <el-form-item label="담당자" prop="charger">
          <el-checkbox v-model="selection.charger" />
          <div class="inline pl-default">
            <el-input v-model="data.charger" @input="handleInputCharger" />
          </div>
        </el-form-item>
        <el-form-item label="구분" prop="delivery_way_flag">
          <el-checkbox v-model="selection.delivery_way_flag" />
          <div class="inline pl-default">
            <el-select v-model="data.delivery_way_flag" placeholder="구분" @change="handleChangeDeliveryWay">
              <el-option
                v-for="item in deliveryWayFlagOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="비고" prop="desc">
          <el-checkbox v-model="selection.desc" />
          <div class="inline pl-default">
            <el-input v-model="data.desc" @input="handleInputDesc" />
          </div>
        </el-form-item>
        <el-form-item label="도어조립" prop="assemble_cancel">
          <el-checkbox v-model="selection.assemble_cancel">도어조립 일정 취소</el-checkbox>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="disableRegister"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
      >{{$t('button.register')}}(F4)</el-button>
      <el-button class="close-button" @click="handleCloseDialog">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "ScheduleBulkChange",
  data() {
    let validateScheduleDate = (rule, value, callback) => {
      if (!this.selection.schedule_date || this.data.schedule_date) {
        callback();
      } else {
        callback(new Error("일자를 선택해 주세요."));
      }
    };
    return {
      title: this.$t('title.integrated_schedule'),
      selection: {
        schedule_date: false,
        charger: false,
        delivery_way_flag: false,
        desc: false,
        assemble_cancel: false,
      },
      data: {
        schedule_date: null,
        charger: null,
        delivery_way_flag: null,
        desc: null,
      },
      rules: {
        schedule_date: [{ validator: validateScheduleDate, trigger: "blur" }],
      },
    }    
  },  
  props: {
    ids: {
      type: Array,
      required: true
    }
  },
  computed: {
    disableRegister() {
      return !this.selection.schedule_date && !this.selection.charger
      && !this.selection.delivery_way_flag && !this.selection.desc 
      && !this.selection.assemble_cancel;
    },
    deliveryWayFlagOption: function() {
      return this.system.options.delivery_way_flag;
    },
  },
  methods: {
    doRegister() {
      let data = {};
      if (this.selection.schedule_date) {
        data.schedule_date = this.data.schedule_date;
      }
      if (this.selection.charger) {
        data.charger = this.data.charger;
      }
      if (this.selection.delivery_way_flag) {
        data.delivery_way_flag = this.data.delivery_way_flag;
      }
      if (this.selection.desc) {
        data.desc = this.data.desc;
      }
      if (this.selection.desc) {
        data.desc = this.data.desc;
      }
      if (this.selection.assemble_cancel) {
        data.assemble_cancel = true;
      }
      let param = {
        ids: this.ids,
        data: data
      }
      this.api.updateScheduleBulk(param).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed", true);
      });
    },
    handleChangeScheduleDate() {
      this.selection.schedule_date = !!this.data.schedule_date;
    },
    handleInputCharger() {
      this.selection.charger = true;
    },
    handleChangeDeliveryWay() {
      this.selection.delivery_way_flag = true;
    },
    handleInputDesc() {
      this.selection.desc = true;
    },
    handleClickRegister() {
      this.$refs.form.validate(valid => {
        if (!valid) { return; }
        this.doRegister();
      });
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
  },  
}
</script>
